import { AnchorIcon, SkullIcon } from '@/components/game/GameIcons'
import { alignmentGaugePercent } from '@/lib/reputation'

const CAP = 300

/**
 * Jauge horizontale de l'axe loyalty (−1500 … +1500) : moitié Flibuste (gauche,
 * rouille) / moitié Couronne (droite, océan), ticks « cap d'achat » à ±300,
 * marqueur plein = position actuelle, marqueur fantôme = prévisualisation
 * après achat. Purement présentationnel.
 */
export function AlignmentGauge({ loyalty, preview }: { loyalty: number; preview: number | null }) {
  const pct = alignmentGaugePercent

  return (
    <div>
      <div className="relative h-12">
        <div className="absolute top-1/2 -translate-y-1/2 left-0 right-1/2 h-2 rounded-l-full bg-rum-700/60" />
        <div className="absolute top-1/2 -translate-y-1/2 left-1/2 right-0 h-2 rounded-r-full bg-ocean-500/60" />
        {[-CAP, CAP].map((v) => (
          <div
            key={v}
            className="absolute top-1/2 -translate-y-1/2 w-px h-5 bg-sand-500/50"
            style={{ left: `${pct(v)}%` }}
            title={`Cap d'achat ±${CAP}`}
          />
        ))}
        {preview !== null && preview !== loyalty && (
          <span
            data-testid="gauge-preview"
            className="absolute top-1/2 w-3.5 h-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-dashed border-sand-300/80 bg-ocean-900 transition-[left] duration-200"
            style={{ left: `${pct(preview)}%` }}
          />
        )}
        <span
          data-testid="gauge-current"
          className="absolute top-1/2 w-3.5 h-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-sand-300 ring-4 ring-sand-300/25"
          style={{ left: `${pct(loyalty)}%` }}
          title={`Alignement ${loyalty >= 0 ? '+' : ''}${loyalty}`}
        />
      </div>
      <div className="flex justify-between text-[10px] uppercase tracking-wider text-ocean-300">
        <span className="inline-flex items-center gap-1"><SkullIcon className="w-3.5 h-3.5" /> Flibuste · hors-la-loi</span>
        <span className="inline-flex items-center gap-1">Couronne · loyal <AnchorIcon className="w-3.5 h-3.5" /></span>
      </div>
    </div>
  )
}
